import axios from 'axios';
let paths;
export const setApiPathsPlugin = (allPaths) => {
    paths = allPaths;
};
export const postQuestion = (question) => axios.post(paths.app_contact_form, question);
export const getResellers = () => axios.get(paths.app_ajax_resellers).then(response => response.data);
export const getStores = () => axios.get(paths.app_ajax_store_locator_pins).then(response => response.data);
export const getCustomWorkTimes = () => axios.get(paths.app_ajax_store_locator_pin_custom_work_times).then(response => response.data);
